import axios from "axios";

export const ContentManagerRequest = axios.create({
    baseURL: process.env.REACT_APP_CONTENT_MANAGER_API

})
